import type { ComponentMode, FileOwnerType, Tag, TagStatus } from 'types';

interface State extends Tag {
  mode: ComponentMode;
  step: 1 | 2;
  ownerType: FileOwnerType;
  defaultStatus: TagStatus;
  defaultTitle: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_TAG_TITLE';
      payload: Pick<typeof initialState, 'title'>;
    }
  | {
      type: 'UPDATE_TAG_SLUG';
      payload: Pick<typeof initialState, 'slug'>;
    }
  | {
      type: 'UPDATE_TAG_DESCRIPTION';
      payload: Pick<typeof initialState, 'description'>;
    }
  | {
      type: 'UPDATE_TAG_SEO';
      payload: Pick<typeof initialState, 'seo'>;
    }
  | {
      type: 'UPDATE_TAG_CATEGORIES';
      payload: Pick<typeof initialState, 'categories'>;
    }
  | {
      type: 'UPDATE_TAG_STEP';
      payload: Pick<typeof initialState, 'step'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
